export default "__VITE_ASSET__BG0X6uCH__"